import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '@client/shared/shared.module';
import { BaseComponent } from '@shared/component/base/base.component';
import { TourService } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-tour',
  imports: [SharedModule],
  templateUrl: './tour.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tour.component.scss',
})
export class TourComponent extends BaseComponent {
  protected tourService = inject(TourService);
}
